import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TokenStorageService} from "../../feature/login/services/token-storage.service";
import {AuthService} from "../../feature/login/services/auth.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly tokenStorageService: TokenStorageService, private readonly authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authToken = this.tokenStorageService.getToken();
    let authRequest = request;
    if (authToken !== null) {
      authRequest = this.addTokenToHeader(request, authToken);
    }

    return next.handle(authRequest);
  }

  private addTokenToHeader(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) });
  }
}
